module.exports = __webpack_public_path__ + "static/img/no-dev-list.6aa1663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-dev-list.png
// module id = +05B
// module chunks = 1